// Shared labels, status/badge color maps for INDAR gestionale.

export const STATO_CORSO = {
  bozza: { label: "Bozza", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  pianificato: { label: "Pianificato", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  configurato: { label: "Configurato", cls: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  iscrizioni_aperte: { label: "Iscrizioni Aperte", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  in_erogazione: { label: "In Erogazione", cls: "bg-green-50 text-green-700 border-green-200" },
  concluso: { label: "Concluso", cls: "bg-purple-50 text-purple-700 border-purple-200" },
  in_rendicontazione: { label: "In Rendicontazione", cls: "bg-teal-50 text-teal-700 border-teal-200" },
  chiuso: { label: "Chiuso", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  archiviato: { label: "Archiviato", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  annullato: { label: "Annullato", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export const MACRO_TIPOLOGIA = {
  fse_gol: { label: "FSE / GOL", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  fondi_interprofessionali: { label: "Fondi Interprof.", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  non_finanziato_mono: { label: "A Pagamento (Mono)", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  non_finanziato_pluri: { label: "A Pagamento (Pluri)", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  treu: { label: "TREU", cls: "bg-yellow-50 text-yellow-800 border-yellow-200" },
};

export const PRIORITA = {
  bassa: { label: "Bassa", cls: "bg-slate-100 text-slate-600" },
  normale: { label: "Normale", cls: "bg-blue-50 text-blue-700" },
  alta: { label: "Alta", cls: "bg-amber-100 text-amber-800" },
  urgente: { label: "Urgente", cls: "bg-rose-100 text-rose-700" },
};

export const STATO_TASK = {
  da_fare: "Da fare",
  in_corso: "In corso",
  in_revisione: "In revisione",
  completata: "Completata",
  annullata: "Annullata",
};

export const STATO_ISCRIZIONE = {
  pre_iscritto: "Pre-iscritto",
  confermato: "Confermato",
  ritirato: "Ritirato",
  completato: "Completato",
  non_idoneo: "Non idoneo",
};

export function fmtDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return s;
  }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return s;
  }
}

export function fmtEuro(v) {
  if (v == null) return "—";
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v);
}
